import { useMemo } from 'react';
import { useUrlState } from '@/hooks/useUrlState';
import { compact, urlField } from '@/lib/urlState';
import { ServiceListParams } from '@/types';

const SERVICES_SCHEMA = {
  page: urlField.page(),
  sortBy: urlField.enum(
    ['name', 'updatedAt', 'price', 'type', 'childrenCount'] as const,
    'updatedAt',
  ),
  sortOrder: urlField.enum(['asc', 'desc'] as const, 'desc'),
  term: urlField.string(),
  jurisdiction: urlField.string(),
  strictJurisdiction: urlField.boolean(),
  currency: urlField.string(),
  type: urlField.string(),
  minPrice: urlField.number(null),
  maxPrice: urlField.number(null),
  exclude: urlField.numberArray(),
  serviceFilter: urlField.enum(['', 'packages', 'standalone'] as const, ''),
};

export function useServicesFilters() {
  const [state, setState, { clear, isFiltered }] = useUrlState(
    SERVICES_SCHEMA,
    { memoryKey: '/products', viewKeys: ['sortBy', 'sortOrder'] },
  );

  const filters = useMemo(
    (): ServiceListParams =>
      compact({
        page: state.page,
        sortBy: state.sortBy,
        sortOrder: state.sortOrder,
        term: state.term || undefined,
        jurisdiction: state.jurisdiction || undefined,
        strictJurisdiction: state.strictJurisdiction || undefined,
        currency: state.currency || undefined,
        type: state.type || undefined,
        minPrice: state.minPrice ?? undefined,
        maxPrice: state.maxPrice ?? undefined,
        exclude: state.exclude.length ? state.exclude : undefined,
        serviceFilter: state.serviceFilter || undefined,
      }),
    [state],
  );

  return { state, filters, setState, clearFilters: clear, isFiltered };
}
